import p5 from 'p5';
import { waterMarkForBg } from './template-helper';

/*
 * The Hall of Fame Sketch
 *
 * A template designed to showcase wrestlers on a club / team
 */

// Square version
const squareSketch = function (p) {
  let watermarkDark;
  let watermarkLight;
  let interBlack;
  p.preload = function () {
    watermarkDark = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium.png');
    watermarkLight = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium_light.png');
    interBlack = p.loadFont('https://mktg-cdn.wrestlingiq.com/promos/fonts/Inter-Black.otf');
  }

  // These are the user editable areas of this template
  p.wrestlerName = ""
  p.clubName = ""
  p.accomplishments = ""
  p.accomplishmentsline2 = ""
  p.heroImage = null
  // $n9
  p.frameColor = "#102A42"
  p.bgColor = "#FFF"
  p.textColor = "#102A42"
  // We expose this configuration array so the promo-generator component can show them to the user
  p.userEditableFields = function() {
    return [
      {
        id: 1,
        prompt: "Name",
        placeholder: "e.g. wrestler or coach name",
        type: "text",
        property: "wrestlerName",
      },
      {
        id: 2,
        prompt: "Team name",
        placeholder: "",
        type: "text",
        property: "clubName",
      },
      {
        id: 3,
        prompt: "Accomplishments",
        placeholder: "e.g. medalist, state placer",
        type: "text",
        property: "accomplishments",
      },
      {
        id: 4,
        prompt: "Accomplishments (line 2)",
        placeholder: "",
        type: "text",
        property: "accomplishmentsline2",
      },
      {
        id: 5,
        prompt: "Hero image",
        placeholder: "",
        type: "photo",
        property: "heroImage",
        pinturaOpts: {
          imageCropAspectRatio: 16 / 9,
        }
      },
      {
        id: 6,
        prompt: "Background color",
        placeholder: "",
        type: "color",
        property: "bgColor",
      },
      {
        id: 7,
        prompt: "Text color",
        placeholder: "",
        type: "color",
        property: "textColor",
      },
      {
        id: 8,
        prompt: "Frame color",
        placeholder: "",
        type: "color",
        property: "frameColor",
      }
    ]
  }
  // This is the off screen graphics buffer that contains the true dimensions
  // It is used when we need to save/download the image
  let pg;
  // p5 setup hook
  p.setup = function () {
    // TODO something about density and exports? Or just leave as is
    //  let density = p.pixelDensity()
    p.createCanvas(500, 500);
    pg = p.createGraphics(1080, 1080);
    p.noLoop();
  };
  // p5 draw loop
  p.draw = function () {
    // Draw into the offscreen graphics buffer
    pg.clear()
    pg.fill(p.bgColor)
    pg.noStroke()
    pg.rect(10, 10, 1060, 1060);
    p.describe(
      'white background, slightly pulled in so rounded corner edges are transparent'
    );

    // Use the user uploaded image if we can
    if (p.heroImage) {
      // Based on https://github.com/processing/p5.js/issues/5641
      const pImg = new p5.Image(1, 1);

      pImg.width = pImg.canvas.width = p.heroImage.width;
      pImg.height = pImg.canvas.height = p.heroImage.height;

      // Draw the image into the backing canvas of the p5.Image
      pImg.drawingContext.drawImage(p.heroImage, 0, 0);
      pImg.modified = true;
      // Draw it into the graphics buffer into the 16/9 placeholder slot
      pg.image(pImg, 10, 10, 1060, 596)
    }

    // Add the frame
    pg.noFill();
    pg.strokeWeight(10);
    pg.stroke(p.frameColor);
    pg.rect(5, 5, 1070, 1070, 20);
    p.describe(
      'white rounded corner frame around entire image'
    );
    pg.line(5, 610, 1070, 610);
    p.describe(
      'a horizontal line across the entire image a little over halfway down the canvas'
    );

    pg.fill(p.textColor);
    pg.strokeWeight(0);
    pg.textSize(64);
    pg.textFont(interBlack);
    pg.text(p.wrestlerName, 64, 784);
    p.describe('Text for the wrestler name')
    pg.textSize(32);
    pg.textFont(interBlack);
    pg.text(p.clubName, 64, 850);
    p.describe('Text for the club name')
    pg.textFont(interBlack);
    pg.text(p.accomplishments, 64, 891);
    p.describe('Text for accomplishments')
    pg.textFont(interBlack);
    pg.text(p.accomplishmentsline2, 64, 932);
    p.describe('Text for accomplishments line 2')

    // WrestlingIQ watermark
    let watermark = waterMarkForBg(p.bgColor, watermarkLight, watermarkDark);
    pg.image(watermark, 900, 980, 140, 42);
    // Now output the graphics buffer into the canvas element for the 'preview'
    p.image(pg, 0, 0, 500, 500)
  };

  // Exporting to the users disk
  p.exportGraphicBuffer = function() {
    pg.save('hall_of_fame_square.png')
  }

  // Cleanup method for destroying things
  p.canvasWillBeRemoved = function() {
    // Remove the elements
    pg.remove();
    // Explicitly set it to null so it gets garbage collected
    pg = null;
  }
};

export const hallOfFameSquare = (node) => {
  return new p5(squareSketch, node);
};

// Facebook / landscape version
const landscapeSketch = function (p) {
  let watermarkDark;
  let watermarkLight;
  let interBlack;
  p.preload = function () {
    watermarkDark = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium.png');
    watermarkLight = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium_light.png');
    interBlack = p.loadFont('https://mktg-cdn.wrestlingiq.com/promos/fonts/Inter-Black.otf');
  }

  // These are the user editable areas of this template
  p.wrestlerName = ""
  p.clubName = ""
  p.accomplishments = ""
  p.accomplishmentsline2 = ""
  p.heroImage = null
  // $n9
  p.frameColor = "#102A42"
  p.bgColor = "#FFF"
  p.textColor = "#102A42"
  // We expose this configuration array so the promo-generator component can show them to the user
  p.userEditableFields = function() {
    return [
      {
        id: 1,
        prompt: "Name",
        placeholder: "e.g. wrestler or coach name",
        type: "text",
        property: "wrestlerName",
      },
      {
        id: 2,
        prompt: "Team name",
        placeholder: "",
        type: "text",
        property: "clubName",
      },
      {
        id: 3,
        prompt: "Accomplishments",
        placeholder: "e.g. medalist, state placer",
        type: "text",
        property: "accomplishments",
      },
      {
        id: 4,
        prompt: "Accomplishments (line 2)",
        placeholder: "",
        type: "text",
        property: "accomplishmentsline2",
      },
      {
        id: 5,
        prompt: "Hero image",
        placeholder: "",
        type: "photo",
        property: "heroImage",
        pinturaOpts: {
          imageCropAspectRatio: 39 / 61,
        }
      },
      {
        id: 6,
        prompt: "Background color",
        placeholder: "",
        type: "color",
        property: "bgColor",
      },
      {
        id: 7,
        prompt: "Text color",
        placeholder: "",
        type: "color",
        property: "textColor",
      },
      {
        id: 8,
        prompt: "Frame color",
        placeholder: "",
        type: "color",
        property: "frameColor",
      }
    ]
  }
  // This is the off screen graphics buffer that contains the true dimensions
  // It is used when we need to save/download the image
  let pg;
  // p5 setup hook
  p.setup = function () {
    // TODO something about density and exports? Or just leave as is
    //  let density = p.pixelDensity()
    p.createCanvas(600, 315);
    pg = p.createGraphics(1200, 630);
    p.noLoop();
  };
  // p5 draw loop
  p.draw = function () {
    // Draw into the offscreen graphics buffer
    pg.clear()
    pg.fill(p.bgColor)
    pg.noStroke()
    pg.rect(10, 10, 1190, 620);
    p.describe(
      'white background, slightly pulled in so rounded corner edges are transparent'
    );

    // Use the user uploaded image if we can
    if (p.heroImage) {
      // Based on https://github.com/processing/p5.js/issues/5641
      const pImg = new p5.Image(1, 1);

      pImg.width = pImg.canvas.width = p.heroImage.width;
      pImg.height = pImg.canvas.height = p.heroImage.height;

      // Draw the image into the backing canvas of the p5.Image
      pImg.drawingContext.drawImage(p.heroImage, 0, 0);
      pImg.modified = true;
      // Draw it into the graphics buffer into the vertical rectangle slot
      pg.image(pImg, 10, 10, 400, 620)
    }

    // Add the white triangle to get the diagonal slash effect
    pg.quad(250, 10, 405, 620, 415, 620, 415, 10);
    p.describe('Triangle to create slashing effect on image/frame');


    // Add the frame
    pg.noFill();
    pg.strokeWeight(10);
    pg.stroke(p.frameColor);
    pg.rect(5, 5, 1190, 620, 20);
    p.describe(
      'white rounded corner frame around entire image'
    );
    pg.line(250, 10, 400, 620);
    p.describe(
      'a slashing horizontal line across the entire image a little over halfway down the canvas'
    );

    // Draw the text
    pg.fill(p.textColor);
    pg.strokeWeight(0);
    pg.textSize(64);
    pg.textFont(interBlack);
    pg.text(p.wrestlerName, 400, 175);
    p.describe('Text for the wrestler name')
    pg.textSize(32);
    pg.textFont(interBlack);
    pg.text(p.clubName, 400, 250);
    p.describe('Text for the club name')
    pg.textFont(interBlack);
    pg.text(p.accomplishments, 400, 298);
    p.describe('Text for accomplishments')
    pg.textFont(interBlack);
    pg.text(p.accomplishmentsline2, 400, 346);
    p.describe('Text for accomplishments line 2')

    // WrestlingIQ watermark
    let watermark = waterMarkForBg(p.bgColor, watermarkLight, watermarkDark);
    pg.image(watermark, 1025, 550, 140, 42);
    // Now output the graphics buffer into the canvas element for the 'preview'
    p.image(pg, 0, 0, 600, 315)
  };

  // Exporting to the users disk
  p.exportGraphicBuffer = function() {
    pg.save('hall_of_fame_landscape.png')
  }

  p.canvasWillBeRemoved = function() {
    // Remove the elements
    pg.remove();
    // Explicitly set it to null so it gets garbage collected
    pg = null;
  }
};

export const hallOfFameLandscape = (node) => {
  return new p5(landscapeSketch, node);
};


export const hallOfFameDimensions = () => {
  return [
    {
      title: "Square",
      dimensions: "1080x1080",
      selected: false,
      initializer: hallOfFameSquare,
    },
    {
      title: "Horizontal Banner",
      dimensions: "1200x630",
      selected: false,
      initializer: hallOfFameLandscape,
    }
  ]
};

export const hallOfFamePreviewImg = () => {
  return "https://mktg-cdn.wrestlingiq.com/promos/hall-of-fame/hall_of_fame_square_preview.png"
}
